// istanbul ignore file

type ActiveIntegration = {
    id: number;
    software: {
        name: string;
    };
    createdAt: string;
    stats: {
        receivedFromIntegrationCount: number;
        integratedCount: number;
    };
};

type IntegratedPropertyManager = {
    name: string;
    ref: string;
};

enum IntegratedCompliancePropertyStatus {
    Compliant = 'COMPLIANT',
    ComplianceIssues = 'COMPLIANCE_ISSUES',
    NonResidentialProperty = 'NON_RESIDENTIAL_PROPERTY'
}

enum IntegratedComplianceServiceStatus {
    Compliant = 'COMPLIANT',
    /**
     * All fields are valid, but the service is overdue
     */
    NonCompliant = 'NON_COMPLIANT',
    GasConfirmationRequired = 'GAS_CONFIRMATION_REQUIRED',
    MissingSupplierAndLastServiceDate = 'MISSING_SUPPLIER_AND_LAST_SERVICE_DATE',
    MissingSupplier = 'MISSING_SUPPLIER',
    MissingLastServiceDate = 'MISSING_LAST_SERVICE_DATE',
    FurtherWorksRequired = 'FURTHER_WORKS_REQUIRED',
    NotRequired = 'NOT_REQUIRED',
    Unknown = 'UNKNOWN'
}

enum IntegratedPropertyTags {
    Compliant = 'COMPLIANT',
    ComplianceIssues = 'COMPLIANCE_ISSUES',
    RecentlyAdded = 'RECENTLY_ADDED',
    UnderEnrolment = 'UNDER_ENROLMENT'
}

enum IntegratedPropertyServiceTags {
    MissingSupplier = 'MISSING_SUPPLIER',
    MissingLastServiceDate = 'MISSING_LAST_SERVICE_DATE',
    Overdue = 'OVERDUE',
    ApproachingNextService = 'APPROACHING_NEXT_SERVICE',
    GasConfirmationRequred = 'GAS_CONFIRMATION_REQUIRED',
    PotentialDiSupplier = 'POTENTIAL_DI_SUPPLIER',
    FurtherWorksRequired = 'FURTHER_WORKS_REQUIRED'
}

enum ServicingStatuses {
    ApproachingNextService = 'APPROACHING_NEXT_SERVICE',
    Overdue = 'OVERDUE'
}

enum IntegrationSoftwareCodes {
    PropertyTree = 'PROPERTY_TREE',
    PropertyMe = 'PROPERTY_ME',
    PropertyMeOld = 'PROPERTY_ME_(OLD_API)',
    ManagedApp = 'MANAGED_APP',
    ConsoleCloud = 'CONSOLE_CLOUD',
    Console = 'CONSOLE',
    Kolmeo = 'KOLMEO',
    OurProperty = 'OUR_PROPERTY',
    PalaceLegacy = 'PALACE_LEGACY',
    PalaceLiquid = 'PALACE_LIQUID',
    Rest = 'REST',
    RPOffice = 'RPOFFICE',
    VaultRE = 'VAULTRE'
}

export {
    ActiveIntegration,
    IntegratedPropertyManager,
    IntegratedPropertyTags,
    IntegratedPropertyServiceTags,
    IntegrationSoftwareCodes,
    ServicingStatuses,
    IntegratedComplianceServiceStatus,
    IntegratedCompliancePropertyStatus,
};
